interface Tokens {
    iconData: string;
    iconTitle: string;
}

/**
 * Change the title attribute of a custom Icon
 * @param tokens The tokens object of the custom Icon
 * @param newTitle The title the icon should have
 */
export function reTitle<T extends Tokens>(tokens: T, newTitle: string): T {
    return {
        ...tokens,
        iconData: tokens.iconData.replace(new RegExp(`${tokens.iconTitle}`, 'g'), newTitle)
    };
}
